"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authCustomerApiPaths = void 0;
const getCustomerById = (id) => `/v1/customer/${id}`;
const getCustomerOrderToReview = (customerId) => `${getCustomerById(customerId)}/orders/orderToReview`;
exports.authCustomerApiPaths = {
    getCustomerById,
    getCustomerOrderToReview,
};
